module.exports = __webpack_public_path__ + "img/imgHeader_05.fb2c8b16.png";